export const now = new Date()

/**
 * @param {Date | string | number | undefined | null=} date
 * @returns {Date}
 */
export function weekAgo (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  date.setDate(date.getDate() - 7)
  return date
}

/**
 * @param {Date | string | number | undefined | null=} date
 * @returns {Date}
 */
export function monthAgo (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  date.setDate(date.getDate() - 30)
  return date
}

/**
 * @param {Date | string | number | undefined | null=} date
 * @returns {Date}
 */
export function threeMonthAgo (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  if (date.getMonth() === 0) {
    return new Date(date.getFullYear() - 1, 10, 1)
  } else {
    return new Date(date.getFullYear(), date.getMonth() - 2, 1)
  }
}

/**
 * @param {Date | string | number | undefined | null=} date
 * @returns {Date}
 */
export function yearAgo (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  date.setFullYear(date.getFullYear() - 1)
  return date
}

/**
 * @param {Date | string | number | undefined | null=} date
 * @returns {Date}
 */
export function threeYearsAgo (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  date.setFullYear(date.getFullYear() - 3)
  return date
}

/**
 * @param {Date | string | number | undefined | null=} date incomingDate
 * @returns {Date}
 */
export function lastDayOfMonth (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  const Year = date.getFullYear()
  const Month = date.getMonth() + 1
  return new Date(new Date(Year, Month, 1))
}

/**
 * @param {Date | string | number | undefined | null=} date incomingDate
 * @returns {Date}
 */
export function firstDayOfMonth (date) {
  if (!date) {
    date = new Date(now)
  } else {
    date = new Date(date)
  }

  const Year = date.getFullYear()
  const Month = date.getMonth()
  return new Date(new Date(Year, Month, 1))
}

/**
 * @param {Date | string | number} incomingDate incomingDate
 * @param {string} locale
 * @param {string} timeZone
 * @returns {string}
 */
export function toHumanDate (incomingDate, locale, timeZone = undefined) {
  if (!incomingDate) {
    return '--'
  }

  const date = new Date(incomingDate)
  const dateStringOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: timeZone
  }

  const dateStringOptions2 = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone
  }

  return `${date.toLocaleString(locale, dateStringOptions)}, <span class="text-color-silver">${date.toLocaleString(locale, dateStringOptions2)}</span>`
}

/**
 * @param {Date | string | number} incomingDate incomingDate
 * @param {string} locale
 * @param {string} timeZone
 * @returns {string}
 */
export function toHoursMinutesDate (incomingDate, locale, timeZone = undefined) {
  if (!incomingDate) {
    return '--'
  }

  const date = new Date(incomingDate)

  const dateStringOptions = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timeZone
  }

  return date.toLocaleString(locale, dateStringOptions)
}

/**
 * @param {Date | string | number} incomingDate incomingDate
 * @param {string} locale
 * @param {Boolean} withYear
 * @param {string} timeZone
 * @returns {string}
 */
export function toSimpleDate (incomingDate, locale, withYear = false, timeZone = undefined) {
  if (!incomingDate) {
    return '--'
  }

  const date = new Date(incomingDate)
  const dateStringOptions = {
    day: 'numeric',
    month: 'numeric',
    year: withYear ? 'numeric' : undefined,
    timeZone: timeZone
  }

  return `${date.toLocaleString(locale, dateStringOptions)}`
}

export function toMonthDate (incomingDate, locale, withYear = false, timeZone = undefined) {
  if (!incomingDate) {
    return '--'
  }

  const date = new Date(incomingDate)
  const dateStringOptions = {
    month: 'long',
    year: withYear ? 'numeric' : undefined,
    timeZone: timeZone
  }

  return `${date.toLocaleString(locale, dateStringOptions)}`
}
